var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "playContainer",
      staticClass: "video-player",
      class: { isshowmask: _vm.isOpenShare || !_vm.onLine }
    },
    [
      _c("Xgplayer", {
        staticClass: "video-file",
        class: _vm.startStyle,
        attrs: { id: "HF", config: _vm.Videoconfig },
        on: {
          player: function($event) {
            _vm.Player = $event
          }
        }
      }),
      _vm._v(" "),
      !_vm.isWifi
        ? _c("div", { staticClass: "bg" }, [
            _c("div", { staticClass: "wifidetail" }, [
              _c("p", [_vm._v("正在使用非WIFI网络")]),
              _vm._v(" "),
              _c("p", [_vm._v("视频总长01:35 请注意流量消耗")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: { id: "playVideo" },
                  on: {
                    click: function($event) {
                      return _vm.playVideoStart()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/img/playVideo.png") }
                  })
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1818c948", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1818c948","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoPlayer.vue
// module id = null
// module chunks = 